import { MotifCard, MotifCardBody, MotifCheckbox, MotifChip, MotifChipGroup } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationChoosePreferredResponseText = (props: any) => {
    const { content, enabledToAnswer } = props;
    const [selected, setSelected] = React.useState<any>();
    const dispatch = useDispatch();
    const selectOption = (option: number) => {
        setSelected(option)
    }
    const renderOptions = useCallback(() => {
        const { options } = content;
        return (
            <div className="flex gap-2">
                {options?.map((option: any, index: number) => {
                    const random = Math.random();
                    return (
                        <MotifCard onClick={() => selectOption(index)} key={index} className={`!w-full cursor-pointer ${selected === index && "bg-[#393939c4] !border-b-[#918417]"}`}>
                            <div className="flex items-center justify-between">
                                <span className="bg-[#8c8c8c59] px-2 py-1 font-bold">
                                    {option?.title}
                                </span>
                                <MotifCheckbox
                                    id={`${random}-checkbox-1`}
                                checked={selected === index}
                                // onChange={() => onChange("1")}
                                >{''}</MotifCheckbox>
                            </div>
                            <MotifCardBody>
                                <p>
                                    {option?.text}
                                </p>
                            </MotifCardBody>
                        </MotifCard>
                    )
                })}
            </div>
        )
    }, [enabledToAnswer, selected])
    return (
        <MotifCard className="!w-full">
            <MotifCardBody className="conversation-option-select">
                <p className="text-lg font-bold mb-4">
                    {content.title}
                </p>
                {renderOptions()}
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationChoosePreferredResponseText